import React, {FunctionComponent} from "react";

type FadeContainerProps = {
    fadeTime?: number;
};

const Fade: FunctionComponent<FadeContainerProps> = ({fadeTime = 1.8, children}) => (
    <div style={{animation: `fadeOut ease ${fadeTime}s`}}>{children}</div>
);

export default Fade;
